import { StyleSheet, type ViewStyle } from 'react-native';

export const xxsmall = 4;
export const xsmall = 6;
export const small = 8;
export const medium = 16;
export const large = 24;
export const xlarge = 40;
export const xxlarge = 80;

export const spineSpacing = {
    0: 0,
    100: 4,
    200: 8,
    400: 16,
    500: 20,
    600: 24,
    700: 40,
    900: 80,
};

export const Padding = createStyle('padding');
export const Margin = createStyle('margin');

/*
 * Create a combinaison of styles.
 * Ex: all700, right700, left700
 */
function createStyle(prop: string): {
    all0: ViewStyle;
    left0: ViewStyle;
    right0: ViewStyle;
    bottom0: ViewStyle;
    top0: ViewStyle;
    vertical0: ViewStyle;
    horizontal0: ViewStyle;

    // xsmall
    all100: ViewStyle;
    vertical100: ViewStyle;
    horizontal100: ViewStyle;
    right100: ViewStyle;
    left100: ViewStyle;
    top100: ViewStyle;
    bottom100: ViewStyle;

    // small
    all200: ViewStyle;
    vertical200: ViewStyle;
    horizontal200: ViewStyle;
    right200: ViewStyle;
    left200: ViewStyle;
    top200: ViewStyle;
    bottom200: ViewStyle;

    // medium
    all400: ViewStyle;
    vertical400: ViewStyle;
    horizontal400: ViewStyle;
    right400: ViewStyle;
    left400: ViewStyle;
    top400: ViewStyle;
    bottom400: ViewStyle;

    // medium-large
    all500: ViewStyle;
    vertical500: ViewStyle;
    horizontal500: ViewStyle;
    right500: ViewStyle;
    left500: ViewStyle;
    top500: ViewStyle;
    bottom500: ViewStyle;

    // large
    all600: ViewStyle;
    vertical600: ViewStyle;
    horizontal600: ViewStyle;
    right600: ViewStyle;
    left600: ViewStyle;
    top600: ViewStyle;
    bottom600: ViewStyle;

    // xlarge
    all700: ViewStyle;
    vertical700: ViewStyle;
    horizontal700: ViewStyle;
    right700: ViewStyle;
    left700: ViewStyle;
    top700: ViewStyle;
    bottom700: ViewStyle;

    // xxlarge
    all900: ViewStyle;
    vertical900: ViewStyle;
    horizontal900: ViewStyle;
    right900: ViewStyle;
    left900: ViewStyle;
    top900: ViewStyle;
    bottom900: ViewStyle;
} {
    const styles = {
        all0: {
            [`${prop}Top`]: 0,
            [`${prop}Right`]: 0,
            [`${prop}Bottom`]: 0,
            [`${prop}Left`]: 0,
        },
        left0: {
            [`${prop}Left`]: 0,
        },
        right0: {
            [`${prop}Right`]: 0,
        },
        top0: {
            [`${prop}Top`]: 0,
        },
        bottom0: {
            [`${prop}Bottom`]: 0,
        },
        vertical0: {
            [`${prop}Vertical`]: 0,
        },
        horizontal0: {
            [`${prop}Horizontal`]: 0,
        },
    };

    Object.keys(spineSpacing).forEach((sizeName) => {
        const value = spineSpacing[sizeName];

        styles[`all${sizeName}`] = {
            [prop]: `${value}px`,
        };
        styles[`right${sizeName}`] = {
            [`${prop}Right`]: `${value}px`,
        };
        styles[`left${sizeName}`] = {
            [`${prop}Left`]: `${value}px`,
        };
        styles[`bottom${sizeName}`] = {
            [`${prop}Bottom`]: `${value}px`,
        };
        styles[`top${sizeName}`] = {
            [`${prop}Top`]: `${value}px`,
        };
        styles[`vertical${sizeName}`] = {
            [`${prop}Vertical`]: `${value}px`,
        };
        styles[`horizontal${sizeName}`] = {
            [`${prop}Horizontal`]: `${value}px`,
        };
    });

    // @ts-ignore
    return StyleSheet.create(styles);
}
